<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-11-24 11:07:34
-->
<template>
  <div class="app-container">
    <div class="add-danwei"
         style="background: #fff;height: 100%;padding: 30px 0;">
      <el-form ref="ruleForm"
               :model="viewData"
               style="width:400px;"
               :rules="rules"
               label-width="160px">
        <el-form-item label="网站名称"
                      prop="sitename">
          <el-input v-model="viewData.sitename" />
        </el-form-item>
        <el-form-item label="销假提示语"
                      prop="describe">
          <el-input v-model="viewData.describe" />
        </el-form-item>
        <!-- <el-form-item label="联系人"
                      prop="person">
          <el-input v-model="viewData.person" />
        </el-form-item>
        <el-form-item label="联系方式"
                      prop="phone">
          <el-input v-model="viewData.phone" />
        </el-form-item>
        <el-form-item label="邮箱"
                      prop="email">
          <el-input v-model="viewData.email" />
        </el-form-item>
        <el-form-item label="地址"
                      prop="address">
          <el-input v-model="viewData.address" />
        </el-form-item> -->
        <!-- <el-form-item label="邮编"
                      prop="youbian">
          <el-input v-model="viewData.youbian" />
        </el-form-item>
        <el-form-item label="备案信息"
                      prop="beian_title">
          <el-input v-model="viewData.beian_title" />
        </el-form-item>
        <el-form-item label="备案地址"
                      prop="beian_url">
          <el-input v-model="viewData.beian_url" />
        </el-form-item> -->
      </el-form>
      <div class="fix-fotter">
        <div class="default-btn pointer"
             @click="tijiao('ruleForm')">提交
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fetch from "@/api/console/Config";
export default {
  data () {
    return {
      viewData: {
        sitename: '',
        describe: '',
        person: '',
        phone: '',
        email: '',
        address: '',
        youbian: '',
        beian_title: '',
        beian_url: '',
      },
      rules: {
        sitename: [
          {
            required: true,
            message: "请输入网站名称",
            trigger: "blur",
          },
        ],
        describe: [
          {
            required: true,
            message: "请输入描述",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
  },
  created () {
  },
  mounted () {
    this.resetForm()
    this.getConfig()
  },
  methods: {
    // 获取配置详情
    getConfig () {
      fetch.detail(this.viewData).then(res => {
        if (res.code == 200) {
          this.viewData = res.result
        } else {
          that.$message.error(res.message);
        }
      })
    },
    /**
     * @name: 提交
     * @param {*} formName
     * @return {*}
     * @desc: 
     */
    tijiao (formName) {
      let that = this
      console.log(this.viewData)
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 编辑
          fetch.edit(this.viewData).then(res => {
            if (res.code == 200) {
              that.getConfig()
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          })

        } else {
          // this.$message.warning(this.$t('form.verifyMsg'))
        }
      })
    },
    /**
     * @name: 清空form
     * @return {*}
     * @desc:
     */
    resetForm () {
      this.viewData = {
        sitename: '',
        describe: '',
        person: '',
        phone: '',
        email: '',
        address: '',
        youbian: '',
        beian_title: '',
        beian_url: '',
      }
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
